<template>
  <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
    <div class="w-full p-2 form-content" >
      <div class="flex flex-col items-center mb-6">
        <div class="px-4 mb-6">
          <img
            alt="..."
            class="shadow rounded max-w-full h-auto align-middle border-none"
            :src="input.thumbnail?input.thumbnail:imgPlaceholder"
            style="width: 150px;"
          />
        </div>
        <div class="flex flex-col mb-2">
          <p class="text-xs text-gray-700">Thumbnail (960 x 540 px), Maximum 1MB</p>
        </div>
        <div class="flex flex-col mb-2" v-if="isFileLarge || isFileWrongFormat || ($v.input.thumbnail.$dirty && !$v.input.thumbnail.required)">
          <text-error v-if="isFileLarge" text="Please using image lower than 1MB" />
          <text-error v-if="isFileWrongFormat" text="Invalid image size" />
          <text-error v-if="$v.input.thumbnail.$dirty && !$v.input.thumbnail.required" text="Please select video thumbnail." />
        </div>
        <div class="flex">
          <Button label="Browse File" v-if="!input.thumbnail">
            <template v-slot:any>
              <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                     type="file"
                     name="profile_picture"
                     @change="onFileChange"
              />
            </template>
          </Button>
          <Button label="Remove" variant="default" v-if="input.thumbnail" @clicked="changeImage"></Button>
        </div>
      </div>
      <form-item label='Video Name'>
        <template v-slot>
          <Input
            v-model="input.name"
            placeholder="ex. Video Name"
            :error="$v.input.name.$dirty && (!$v.input.name.required || !$v.input.name.maxLength)"
            maxlength="100"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.name.$dirty && !$v.input.name.required" text="Please fill Video Name." />
            <text-error v-if="$v.input.name.$dirty && !$v.input.name.maxLength" text="Max length Video name is 100 character." />
          </div>
        </template>
      </form-item>
      <form-item label='Video Description'>
        <template v-slot>
          <div class="relative">
            <TextArea
              v-model="input.description"
              placeholder="Description Video"
              :error="$v.input.description.$dirty && (!$v.input.description.required || !$v.input.description.maxLength)"
              rows="5"
            />
            <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{input.description.length}}/{{maxLengthDesc}}</div>
          </div>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.description.$dirty && !$v.input.description.required" text="Please fill the Description." />
            <text-error v-if="$v.input.description.$dirty && !$v.input.description.maxLength" text="Max length description channel is 750 character" />
          </div>
        </template>
      </form-item>
      <form-item label='Type'>
        <template v-slot>
          <Select
            v-model="input.type"
            empty-label="Select Type"
            :error="$v.input.type.$dirty && !$v.input.type.required"
            :data="[{value: 'mission', 'label':'Mission'}, {value: 'podcast', 'label':'Podcast'}, ]"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.type.$dirty && !$v.input.type.required" text="Please fill the Type." />
          </div>
        </template>
      </form-item>
      <form-item label='Category'>
        <template v-slot>
          <div class="flex flex-col">
            <div class="flex flex-col mb-4" v-for="(v, index) in $v.input.category_list.$each.$iter" :key="'cat-' + index">
              <div class="flex">
                <Select
                  v-model="v.id.$model"
                  empty-label="All Categories"
                  :error="v.id.$dirty && !v.id.required"
                  :data="categories"
                />
                <button v-if="index > 0" type="button" @click="removeCategory(index)" class="w-10 ml-2 p-1 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                  <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                </button>
              </div>
              <div class="flex flex-col pt-2">
                <text-error v-if="v.id.$dirty && !v.id.required" text="Please choose category" />
              </div>
            </div>
            <div class="flex w-full justify-center">
              <a @click="addCategory"
                 class="text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-700 hover:text-blue-100
                          text-blue-700
                            border duration-200 ease-in-out
                          border-blue-600 transition">Add another category</a>
            </div>
          </div>
        </template>
      </form-item>
      <form-item label='Language'>
        <template v-slot>
          <el-select v-model="input.language" filterable placeholder="Select Language" class="w-full">
            <el-option
              v-for="item in languages"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.language.$dirty && !$v.input.language.required" text="Please choose language." />
          </div>
        </template>
      </form-item>
      <form-item label='Tag'>
        <template v-slot>
          <el-select
            class="w-full"
            v-model="tagsValue"
            multiple
            filterable
            remote
            allow-create
            default-first-option
            reserve-keyword
            size="large"
            placeholder="Please enter a keyword"
            :remote-method="searchTags"
            :loading="loadingTags">
            <el-option
              v-for="item in tagsOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.tag.$dirty && !$v.input.tag.required" text="Please fill tag." />
          </div>
        </template>
      </form-item>
      <div class="flex flex-wrap px-4 mt-4 mb-2">
        <p v-if="$v.input.file.$dirty && !$v.input.file.required" class="text-red-500 text-xs">Video cannot be empty.</p>
        <div ref="dragDrop"
             class="relative drag-drop px-3 w-full upload-btn-wrapper"
             @drop.prevent="onDrop($event)"
             @dragover.prevent="dragover = true"
             @dragenter.prevent="dragover = true"
             @dragleave.prevent="dragover = false"
        >
          <input type="file" name="fileVideo" @change="onFileChangeVideo" accept="video/mp4" />
          <div class="absolute drag-drop-content flex flex-col w-full">
            <font-awesome-icon  :icon="['fa', 'cloud-upload-alt']" class="icon-drag-drop" /><br />
            <span class="mb-4">Click or Drag Your Files Here</span>
          </div>
          <div class="video-uploaded" v-if="fileVideoPreview">
            <div class="video-uploaded-content">
              <video controls>
                <source :src="fileVideoPreview" type="video/mp4" />
              </video>
              <a @click="replace"
                 class="text-sm w-50 m-auto text-center focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-100 hover:text-blue-700
                          text-blue-100
                            border duration-200 ease-in-out
                          border-blue-600 bg-blue-700 transition">Replace Video</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import helpersMixin from '@/mixins/helpers.mixins';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { FormItem, Input, TextArea, Button, TextError, Select } from '@/components/Layout/Form';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

const API_URL = process.env.API_URL;
const initialStateVideos = {
  channel_id: null,
  id: null,
  name: '',
  description: '',
  category_id: null,
  type: null,
  thumbnail: null,
  language: null,
  duration: null,
  file: null,
  file_name: null,
  tag: '',
  category_list: [{ id: null }],
};
window.URL = window.URL || window.webkitURL;

export default {
  name: 'VideosForm',
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    videoId: {
      type: [Number, null],
      default: () => null,
    },
    channelId: {
      type: [Number, null],
      default: () => null,
    },
  },
  mixins: [validationMixin, helpersMixin],
  data() {
    return {
      maxLengthDesc: 750,
      dragover: false,
      isFileLarge: false,
      isFileWrongFormat: false,
      isError: false,
      input: { ...initialStateVideos },
      tagsValue: [],
      tagsOption: [],
      loadingTags: false,
      languages: [],
      categories: [],
      fileVideoPreview: null,
      dataOrigin: { ...initialStateVideos },
      imgPlaceholder,
    };
  },
  watch: {
    toggleReset: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.resetState();
        }
      },
    },
    listCategoryVideos: {
      immediate: true,
      handler(val) {
        if (val) {
          this.categories = this.listCategoryVideos.map(v => ({
            value: v.id,
            label: v.name,
          }));
        }
      },
    },
  },
  validations() {
    return {
      input: {
        file: {
          required,
        },
        thumbnail: {
          required,
        },
        name: {
          required,
          maxLength: maxLength(100),
        },
        description: {
          required,
          maxLength: maxLength(750),
        },
        language: {
          required,
        },
        type: {
          required,
        },
        category_list: {
          required,
          minLength: minLength(1),
          $each: {
            id: {
              required,
            },
          },
        },
        tag: {
          required,
        },
      },
    };
  },
  computed: {
    ...mapGetters('MissionsVideosModule', ['listCategoryVideos', 'percentCompleted']),
  },
  mounted() {
    this.languages = this.getLanguages();
  },
  methods: {
    ...mapActions('MissionsVideosModule', [
      'requestAddVideos', 'requestEditVideos', 'requestDetailVideos',
    ]),
    ...mapActions('SongModule', ['requestGetTags']),
    async resetState() {
      this.$v.$reset();
      this.isError = false;
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      this.tagsValue = [];
      this.tagsOption = [];
      this.fileVideoPreview = null;
      if (this.videoId) {
        let categoryList = [{ id: null }];
        const detail = await this.requestDetailVideos({ id: this.videoId });
        if (detail.category.length > 0) {
          categoryList = detail.category.map(c => ({
            // eslint-disable-next-line radix
            id: parseInt(c.id),
          }));
        } else if (detail.category_id) {
          categoryList = detail.category_id.toString().split(',').map(c => ({
            // eslint-disable-next-line radix
            id: parseInt(c),
          }));
        }
        this.dataOrigin = { ...detail };
        this.input = {
          ...initialStateVideos,
          channel_id: this.channelId,
          id: detail.id,
          name: detail.name,
          description: detail.description,
          category_id: detail.category_id,
          type: detail.type,
          thumbnail: detail.thumbnail,
          language: detail.language,
          duration: detail.duration,
          file: detail.file,
          file_name: detail.file_name,
          tag: detail.tags,
          category_list: categoryList,
        };
        if (detail.tags !== '') {
          this.tagsValue = detail.tags.split(',');
        }
        this.fileVideoPreview = await this.getVideoFile(detail.file);
      } else {
        this.input = Object.assign({}, initialStateVideos, { channel_id: this.channelId });
      }
    },
    async submit() {
      if (this.tagsValue.length > 0) {
        let tags = '';
        this.tagsValue.forEach((t) => {
          if (t !== '') {
            tags += `${t},`;
          }
        });
        if (tags !== '') {
          tags = tags.substr(0, tags.length - 1);
        }
        this.input.tag = tags;
      }
      this.$v.$touch();
      if (!this.$v.$invalid && !this.isFileLarge && !this.isFileWrongFormat) {
        const dataVideo = new FormData();
        dataVideo.append('channel_id', this.channelId);
        dataVideo.append('name', this.input.name);
        dataVideo.append('description', this.input.description);
        const categoryList = this.input.category_list.map(g => g.id).join(',');
        dataVideo.append('category_id', categoryList);
        dataVideo.append('type', this.input.type);
        dataVideo.append('language', this.input.language);
        dataVideo.append('duration', this.input.duration);
        dataVideo.append('file_name', this.input.file_name);
        dataVideo.append('tag', this.input.tag);
        if (this.dataOrigin.thumbnail !== this.input.thumbnail) {
          const resultThumb = await axios({
            method: 'get',
            url: this.input.thumbnail,
            responseType: 'blob',
          })
            .then(this.processFileBlob);
          dataVideo.append('thumbnail', resultThumb);
        }
        if (this.dataOrigin.file !== this.input.file) {
          dataVideo.append('file', this.input.file);
        }
        if (this.videoId) {
          dataVideo.append('video_id', this.videoId);
          await this.requestEditVideos(dataVideo);
        } else {
          await this.requestAddVideos(dataVideo);
        }
        this.$emit('on-submit-video', true);
      }
    },
    async searchTags(query) {
      if (query !== '') {
        this.loadingTags = true;
        const tags = await this.requestGetTags({ q: query });
        this.loadingTags = false;
        this.tagsOption = tags.map(item => ({ value: item.name, label: item.name }));
      } else {
        this.tagsOption = [];
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    async getVideoFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileVideo = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
      });
      return fileVideo.data;
    },
    onFileChange(e) {
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      const file = e.target.files[0];
      const image = new Image();
      image.onload = (ev) => {
        if ((image.width !== 960 && image.height !== 540)) {
          this.$v.dirty = true;
          this.isFileWrongFormat = true;
        }
      };
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.input.thumbnail = URL.createObjectURL(file);
      image.src = this.input.thumbnail;
    },
    changeImage() {
      this.input.thumbnail = null;
      this.isFileWrongFormat = false;
    },
    loadVideo(file) {
      const fileTypeAllowed = ['video/mp4'];
      if (fileTypeAllowed.includes(file.type)) {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src);
          this.input.duration = Math.round(video.duration);
        };
        video.src = URL.createObjectURL(file);
        this.input.file_name = file.name;
        this.input.file = file;
        this.fileVideoPreview = video.src;
      } else {
        this.$swal('Error', 'File type must be MP4', 'error');
      }
    },
    async onDrop(e) {
      this.dragover = false;
      if (e.dataTransfer.files.length > 0) {
        const file = e.dataTransfer.files[0];
        this.loadVideo(file);
      }
    },
    async onFileChangeVideo(e) {
      const file = e.target.files[0];
      this.loadVideo(file);
      setTimeout(() => {
        e.target.value = null;
      }, 500);
    },
    replace() {
      this.input.file = null;
      this.input.file_name = null;
      this.input.duration = 0;
      this.fileVideoPreview = null;
    },
    addCategory() {
      this.input.category_list.push({
        id: null,
      });
    },
    removeCategory(index) {
      this.input.category_list.splice(index, 1);
    },
  },
  components: { FormItem, Input, TextArea, Button, TextError, Select },
};
</script>

<style scoped>
.form-content{
  min-width: 600px;
}
@media screen and (max-width: 500px){
  .form-content {
    min-width: unset;
  }
}
.upload-btn-wrapper{
  //height: 600px !important;
}
.drag-drop{
  height: 300px;
  background: #E5E5EA;
}
.drag-drop-content{
  top:30%;
  left: 0;
  align-items: center;
  z-index: 1;
}
.video-uploaded{
  position: absolute;
  width: 100%;
  top: 20px;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 2;
}
.video-uploaded .video-uploaded-content{
  width: 60%;
  display: flex;
  flex-direction: column;
}
.video-uploaded .video-uploaded-content video{
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
}
.icon-drag-drop{
  font-size: 4em;
}
</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Videos/VideosForm.vue